import type { QuizQuestion } from '@typing-racer/shared';
import { clear, h } from '../dom.js';

/** Three-question recall quiz shown after a race. Answer by clicking or pressing 1-4. */
export function renderQuiz(root: HTMLElement, questions: QuizQuestion[], onDone: (score: number) => void, onSkip: () => void): () => void {
  let index = 0;
  let score = 0;
  let locked = false;
  const wrap = h('div', { class: 'center' });
  root.append(wrap);

  const keyHandler = (e: KeyboardEvent) => {
    if (locked) return;
    const n = Number(e.key);
    if (n >= 1 && n <= 4) {
      e.preventDefault();
      choose(n - 1);
    } else if (e.key === 'Escape') onSkip();
  };
  addEventListener('keydown', keyHandler);
  const detach = () => removeEventListener('keydown', keyHandler);

  function choose(i: number): void {
    if (locked) return;
    locked = true;
    const q = questions[index]!;
    const correct = i === q.answer;
    if (correct) score++;
    const buttons = [...wrap.querySelectorAll<HTMLButtonElement>('.quiz-opt')];
    buttons.forEach((b, j) => {
      b.disabled = true;
      if (j === q.answer) b.classList.add('right');
      else if (j === i) b.classList.add('wrong');
    });
    const fb = wrap.querySelector('.quiz-feedback');
    if (fb) fb.textContent = correct ? '✅ Correct!' : `❌ Not quite. It was: ${q.options[q.answer]}`;
    setTimeout(() => {
      index++;
      locked = false;
      if (index >= questions.length) {
        detach();
        onDone(score);
      } else show();
    }, correct ? 900 : 1800);
  }

  function show(): void {
    clear(wrap);
    const q = questions[index]!;
    wrap.append(
      h(
        'div',
        { class: 'panel results stack quiz' },
        h('div', { class: 'row', style: 'justify-content:space-between' }, h('h1', {}, '🧠 Recall quiz'), h('span', { class: 'badge' }, `${index + 1} / ${questions.length}`)),
        h('p', { class: 'muted' }, 'How much of what you just typed stuck? Click an answer or press 1-4.'),
        h('div', { class: 'quiz-prompt' }, q.prompt),
        h(
          'div',
          { class: 'quiz-options' },
          q.options.map((opt, i) => h('button', { class: 'quiz-opt', onclick: () => choose(i) }, h('span', { class: 'quiz-key' }, String(i + 1)), opt)),
        ),
        h('div', { class: 'quiz-feedback' }, ''),
        h('div', { class: 'row' }, h('button', { class: 'btn small ghost', onclick: () => { detach(); onSkip(); } }, 'Skip quiz'), h('span', { class: 'muted small' }, `Score so far: ${score}`)),
      ),
    );
  }
  show();
  return detach;
}
